export const PLAN_FEATURES = {
  branches: "branches",
  proposalPdf: "proposal_pdf",
  proposalExcel: "proposal_excel",
  proposalCustom: "proposal_custom",
  employees: "employees",
  employeeAccess: "employee_access",
  reports: "reports",
  analysis: "analysis",
  financeQueue: "finance_queue",
  financeAdvanced: "finance_advanced",
  accounts: "accounts",
};

export function hasPlanFeature(user, feature) {
  if (!feature) return true;
  if (!user) return false;
  if (user.role === "super_admin" || user.ghost_session) return true;
  return Boolean(user.plan_features?.[feature]);
}
